// src/components/icons/AdminIcon.js
/* ------------------------------------------------------------------ */
/* AdminIcon – house glyph linking back to the dashboard                */
/* ------------------------------------------------------------------ */
/**
 * @param {object} props  Regular SVG props (className, onClick, …)
 * @returns {JSX.Element}
 */
export const AdminIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    className="h-8 w-auto fill-tertiary cursor-pointer"
    {...props}
  >
    <path d="M400-480q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47M80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-8 18-13.5 37.5T404-360h-4q-71 0-127.5 18T180-306q-9 5-14.5 14t-5.5 20v32h252q6 21 16 41.5t22 38.5zm560 40-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60zm40-120q33 0 56.5-23.5T760-320t-23.5-56.5T680-400t-56.5 23.5T600-320t23.5 56.5T680-240M400-560q33 0 56.5-23.5T480-640t-23.5-56.5T400-720t-56.5 23.5T320-640t23.5 56.5T400-560m12 320"></path>
  </svg>
);
